import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import MenuLogin from './menu-login';

class Component extends BaseComponent {

    shouldComponentUpdate(nextProps) {
        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ user }) {
        if (user.logged_in) {
            return (
                <user-menu-mobile>
                    <section className='user-details'>
                        <ul>
                            <li className='ub-karmacoins'>
                                <a
                                    href='/store/karma-coins'
                                    className='subcategory'
                                    onClick={() => this.trackClick('My Account - Karma Coins© Balance')}
                                >
                                    <span />
                                    <div className='account-details'>
                                        <h5>Karma Coins Store</h5>
                                        <p>You Have {user.kcs.total.toLocaleString()} Karma Coins</p>
                                    </div>
                                </a>
                            </li>
                            <li className='ub-journal'>
                                <a
                                    href='/member/journal'
                                    className='subcategory'
                                    onClick={() => this.trackClick('My Journal')}
                                >
                                    <span />
                                    <div className='account-details'>
                                        <h5>Your Readings</h5>
                                        <p>View Your Readings Journal</p>
                                    </div>
                                </a>
                            </li>
                            {this.renderVIPLink()}
                            <li className='ub-settings'>
                                <a
                                    href='/member/settings'
                                    className='subcategory'
                                    onClick={() => this.trackClick('My Account - Settings')}
                                >
                                    <span />
                                    <div className='account-details'>
                                        <h5>Account Settings</h5>
                                        <p>Set Your Favorite Tarot Deck</p>
                                    </div>
                                </a>
                            </li>
                            <li className='ub-logout'>
                                <a
                                    href='#logout'
                                    className='subcategory'
                                    onClick={() => this.trackClick('Log Out')}
                                >
                                    <h5>Log Out</h5>
                                </a>
                            </li>
                        </ul>
                    </section>
                </user-menu-mobile>
            );
        }

        return (<MenuLogin />);
    }

    renderVIPLink = () => {
        let href = '/readings-reports/subscription/vip-membership';
        let text = 'Try Our VIP Membership';

        if (
            this.props.user
            &&
            this.props.user.subscriptions
            &&
            this.props.user.subscriptions.vip
        ) {
            href = '/vip/daily-horoscope';
            text = 'My VIP Membership';
        }

        return (
            <li className='ub-vip'>
                <a href={href} onClick={() => this.trackClick('VIP')}>
                    <span />
                    <div className='account-details'>
                        <h5 dangerouslySetInnerHTML={{__html: text}} />
                        <p>Your Unique Horoscopes</p>
                    </div>
                </a>
            </li>
        );
    }

    trackClick = (label) => {
        this.props.trackPromo(['Navigation', label]);
        this.props.trackEvent(['Navigation', 'LI Click', label]);
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
